export class TooltipEventArgs {
    public element: HTMLElement;
    public text: string;
    public title: string;
    public eventArgs: MouseEvent | null;

    constructor(element: HTMLElement, text: string, title: string, eventArgs: MouseEvent | null = null) {
        this.element = element;
        this.text = text;
        this.title = title;
        this.eventArgs = eventArgs;
    }
}
